// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Periods } from '@shared/utils/History/TFInfo';
import { TvBar } from '../TradingViewPrimitives/TvBar';
import { BaseInterval } from '@shared/utils/History/BaseInterval';
export class TvHistoryConvertor {
    convertToTvBarWithTime(baseInterval, bTimeInTicks, period, timeOffset, timeZone) {
        const [barTimeInTicks, barTime] = this.correctBartime(bTimeInTicks, period, timeOffset, timeZone);
        return this.createTvBarFromBaseInterval(baseInterval, barTimeInTicks, barTime, period);
    }
    createTvBarFromBaseInterval(baseInterval, barTimeInTicks, barTime, period) {
        const { Data, Volume } = baseInterval;
        const tvBar = new TvBar();
        tvBar.time = barTimeInTicks;
        tvBar.date = barTime;
        tvBar.open = Data[BaseInterval.OPEN_INDEX];
        tvBar.close = Data[BaseInterval.CLOSE_INDEX];
        tvBar.high = Data[BaseInterval.HIGH_INDEX];
        tvBar.low = Data[BaseInterval.LOW_INDEX];
        if (period === Periods.TIC) {
            tvBar.high = tvBar.open >= tvBar.close ? tvBar.open : tvBar.close;
            tvBar.low = tvBar.open >= tvBar.close ? tvBar.close : tvBar.open;
        }
        if (Volume && Volume > 0 && !isNaN(Volume)) {
            tvBar.volume = Volume;
        }
        return tvBar;
    }
    convertBaseIntervalsToTvBars(baseIntervals, period, timeOffset, timeZone) {
        const tvBars = [];
        for (const baseInterval of baseIntervals) {
            const tvBar = this.convertToTvBar(baseInterval, period, timeOffset, timeZone);
            const length = tvBars.length;
            if (length > 0 && tvBar.time === tvBars[length - 1].time) {
                continue; // если история битая
            }
            tvBars.push(tvBar);
        }
        return tvBars;
    }
    convertToTvBar(baseInterval, period, timeOffset, timeZone) {
        const barTimeInTicks = baseInterval.FLeftTimeTicks;
        return this.convertToTvBarWithTime(baseInterval, barTimeInTicks, period, timeOffset, timeZone);
    }
    correctBartime(barTimeInTicks, period, timeOffset, timeZone) {
        const barTime = new Date(barTimeInTicks);
        if (period < Periods.DAY || period % Periods.SECOND === 0) {
            return [barTimeInTicks, barTime];
        }
        barTime.setMinutes(barTime.getMinutes() - timeOffset);
        const correctedBarTimeInTicks = Date.UTC(barTime.getFullYear(), barTime.getMonth(), barTime.getDate());
        const correctedDate = new Date(correctedBarTimeInTicks);
        // const utcDate = DateTime.fromMillis(barTimeInTicks, { zone: 'UTC' });
        // const dateInTimeZone = utcDate.setZone(timeZone);
        // const dateInTimeZoneWithOffset = dateInTimeZone.plus({ minutes: timeOffset });
        // barTime.setMinutes(barTime.getMinutes() - timeOffset);
        // const correctedBarTimeInTicks = Date.UTC(
        //     dateInTimeZoneWithOffset.year,
        //     dateInTimeZoneWithOffset.month - 1,
        //     dateInTimeZoneWithOffset.day);
        // const correctedDate = new Date(correctedBarTimeInTicks);
        return [correctedBarTimeInTicks, correctedDate];
    }
}
